/**
 * roleTitlesAdmin.service.ts — Admin > Plans > Plan Roles (legacy
 * admin_role_details.php): the account's names for the four built-in staff
 * roles, through GET / PUT /role-titles. Saving needs Admin Access.
 */
import { apiClient } from '@/services/apiClient';
import type { ApiResponse } from '@/types/api.types';

export type RoleType = 'Doctor' | 'Nurse' | 'Coordinator' | 'Receptionist';

export type RoleTitles = Record<RoleType, string>;

/** Legacy's fields, in its order and with its labels. */
export const ROLE_FIELDS: { role: RoleType; label: string }[] = [
  { role: 'Doctor', label: 'Primary Provider' },
  { role: 'Nurse', label: 'Secondary Provider' },
  { role: 'Coordinator', label: 'Facilitator' },
  { role: 'Receptionist', label: 'Initial Contact' },
];

/** Legacy's inputs hold 45 characters (so does the API). */
export const ROLE_TITLE_MAX = 45;

const DEFAULTS: RoleTitles = { Doctor: 'Doctor', Nurse: 'Nurse', Coordinator: 'Coordinator', Receptionist: 'Receptionist' };

function toTitles(raw: Partial<Record<string, unknown>> | undefined): RoleTitles {
  const out = { ...DEFAULTS };
  for (const { role } of ROLE_FIELDS) {
    const v = raw?.[role];
    if (typeof v === 'string' && v.trim() !== '') out[role] = v;
  }
  return out;
}

export function getRoleTitles(): Promise<RoleTitles> {
  return apiClient.get<ApiResponse<{ titles?: Record<string, unknown> }>>('/role-titles').then((r) => toTitles(r.data.data?.titles));
}

export function saveRoleTitles(titles: RoleTitles): Promise<RoleTitles> {
  const body = Object.fromEntries(ROLE_FIELDS.map(({ role }) => [role, titles[role].trim()]));
  return apiClient
    .put<ApiResponse<{ titles?: Record<string, unknown> }>>('/role-titles', { titles: body })
    .then((r) => toTitles(r.data.data?.titles));
}
